package co.maytes.standupbot.dashboard.features.setup

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.shared.dto.setup.SetupCheckReportDto

class SetupCheckStore(private val api: ApiClient) {
    var state: SetupCheckState by mutableStateOf(SetupCheckState())
        private set

    suspend fun run(workspaceId: String): Boolean {
        if (!state.canStart) return false
        state = state.started()
        val res = api.post<Unit, SetupCheckReportDto>(path = "/api/v1/workspaces/$workspaceId/setup-check", body = Unit)
        state =
            when (res) {
                is Result.Ok -> state.finished(res.value)
                is Result.Err -> state.failed(SetupCheckErrors.message(res.error))
            }
        return res is Result.Ok
    }
}
